var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1WHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M240,204c-22,16-43.5,28.6-41,78c-5.5,4.5-7.5,7.5-10.5,10.8c-6,6.6-10.4,14.9-12.6,22.7 c-7.6-7.9-22.2-11.9-32.8-8.6c0-10.2,5.5-24.1,9.3-33.7c3.8-9.7,7-19.8,11.1-29.5c2-4.8,4.3-9.5,6.9-14.1 c5.2-10.1,13.2-17.1,21.6-24.8c4.4-3.6,9.1-6.7,14-9.4s9.9-4.9,15-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M445.5,204.5c7,1.5,23.5,6,28.8,8.3c44.7,18.6,85.2,80.6,59.2,126.7c21.6-11.9,50.7-33.4,59.5-57 c8.4-22.4,12-49,10.5-72.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M180,304.5l-49-5.5c-0.2,1.1-0.3,2.3-0.5,3.5c8.2,20.1,19.6,39.4,37.3,51.6c2.3-5.7,7.5-14,7.7-19.5 C175.5,330,175,314,180,304.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M136.5,314.5c-17.9-20.8-19.4-67.3-16-94c5.6-43.5,22.9-78.7,49.7-114.2c50.5-66.6,141-94,222.3-91.8 c107.3,2.9,203.5,87.4,211,195.5c2.5,36.5-4,62.5-20,87.5c-5.8-27.9-56-69.4-81-77c-16.9-5.2-18.4-6.5-29.2-20.7 c-9.2-12-20.4-22.6-33.8-28.2c-58.7-24.3-145.9-27.8-196.7,17.2c-7.1,6.3-32,26.4-33.3,32.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_3_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M498.1,194l-0.8-17.3c-1.2-15.8-0.6-18.6-7.3-20.9c-1.3-0.4-2.5-0.8-3.8-1.3 c-18.8-6.2-38.4-10.7-58.4-13.7c-3.6-0.5-7.1-1-10.7-1.5c-29.2-4.8-59.2-7.1-89.5-6.1c-3.8,0.1-7.6,0.3-11.4,0.5 c-33,2.2-65.7,7.7-95.7,19.2c-1.4,0.5-2.8,1.1-4.2,1.6c-3,1.2-10.9-0.1-4.9,48.4l0.1,3.5c1.4,9.6,6.1,11.4,10.9,9.8 c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6.1-1.9c14.9-4.2,30-7.4,45.4-9.7c7.7-1.2,15.5-2.1,23.3-2.8c36.8-3,73.3-3,109.3,0.6 c7.2,0.7,14.3,1.5,21.4,2.6c14,2.1,27.7,4.9,41.2,8.5C484.2,216.9,499.9,224.3,498.1,194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M327.7,133.3c30.3-1,60.3,1.3,89.5,6.1c3.6,0.5,7.1,0.9,10.7,1.5c20,3,39.6,7.5,58.4,13.7 c0.2-2.6,0.2-5.3,0.1-7.9c-0.1-3.4-0.3-6.7-0.8-10c-3.1-24.3-15-49.7-35.9-67.1c-3-2.5-6.2-4.8-9.5-6.9 c-17.8-11.8-39.3-16.5-61.6-17.7c-3.7-0.2-7.4-0.3-11.2-0.3c-39.4,0.4-83,4.4-112.5,28.9c-3.1,2.4-6,5-8.7,7.6 c-19.5,19.6-27,45.9-25.7,71.9c30-11.4,62.7-17,95.7-19.2C320.1,133.6,323.9,133.4,327.7,133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M481.5,149.9c-2.6-1-5.2-2.1-7.8-3.1c-17.4-6.6-35.6-11.9-54.2-15.9c-3.7-0.8-7.5-1.6-11.2-2.3 c-41.3-7.9-83.7-8.9-125.4-4.3c-3.8,0.4-7.5,0.9-11.3,1.5c-7.4,1.2-14.7,2.7-21.9,4.7c3.6-31.6,23.2-61.5,53.6-79.5 c0.2-0.1,0.3-0.2,0.5-0.3c-18.1,4.2-35,11.2-48.8,22.7c-3.1,2.4-6,5-8.7,7.6c-19.5,19.6-27,45.9-25.7,71.9 c30-11.4,62.7-17,95.7-19.2c3.8-0.2,7.6-0.4,11.4-0.5c30.3-1,60.3,1.3,89.5,6.1c3.6,0.5,7.1,0.9,10.7,1.5c20,3,39.6,7.5,58.4,13.7 c0.1-0.8,0.1-1.7,0.1-2.5C484.7,151.3,483.1,150.6,481.5,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M240.3,191.7c6.9-14.6,14.9-29.8,8.4-47.6c-9.6,2.5-18.9,5.4-28,8.9c-1.4,0.5-2.8,1.1-4.2,1.6 c-3,1.2-10.9-0.1-4.9,48.4l0.1,3.5c1.4,9.6,6.1,11.4,10.9,9.8c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6.1-1.9 c5-1.4,10.1-2.7,15.2-3.9C241.9,204,238,197.3,240.3,191.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M357.5,34c-12.1-6.5-26.2,1.7-28.6,12.6c11.6-1.3,23.3-1.8,34.8-2C363,40.6,361.8,36.2,357.5,34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M315.5,137.1c3.8-0.2,7.6-0.4,11.4-0.5c30.3-1,60.3,1.3,89.5,6.1c3.6,0.5,7.1,0.9,10.7,1.5 c23.7,3.5,46.8,9.2,68.7,17.3c-0.8-3.2-2.3-4.5-5.8-5.7c-1.3-0.4-2.5-0.8-3.8-1.3c-6.9-2.3-14-4.3-21.1-6.2l-0.3-7.3 c-3.8-31.9-16.9-58.8-42.1-81.6c25.1,23.1,35.7,50.5,39.3,81.7l0.3,6.4c-11.3-2.8-22.7-5.1-34.3-6.8l-0.7-6.7 c-4.4-30.4-14.9-55.5-32.3-81.3c17.1,26.1,25.3,51.6,29.5,81.6l0.7,6.1c-2.7-0.4-5.3-0.7-8-1.1c-10.1-1.7-20.4-3-30.7-4.1 l-0.3-6.3c-1.7-28-3.4-52.3-14-78.4c10.2,26.3,9.6,50.6,11.2,78.5l0.3,5.9c-10.6-1-21.3-1.6-32.1-1.9v-6 c-0.2-26.9-2.7-49.7-7-75.6c4,26,4.2,48.9,4.2,75.6v5.9c-7-0.1-14.1-0.1-21.2,0.2c-3.8,0.1-7.6,0.3-11.4,0.5 c-1.5,0.1-2.9,0.2-4.4,0.3l-0.5-5.4c-1.9-26.6-2.1-50.1,9.2-74.8c-11.7,24.5-13.8,48.1-11.9,75c0.1,1.9,0.3,3.7,0.5,5.5 c-11.7,1-23.3,2.4-34.7,4.3c-0.3-1.7-0.7-3.4-0.9-5.2c-2.7-24.8,0.8-46.9,11.5-69.9c-11.1,22.8-17,44.6-14.3,70.1 c0.2,1.8,0.6,3.6,0.9,5.4c-7.8,1.4-15.5,3-23.1,5c-0.2-1.5-0.5-3.1-0.6-4.6c-1.8-22.9,2.4-42.7,10.5-64.3 c-8.4,21.4-15,40.9-13.3,64.5c0.1,1.8,0.4,3.5,0.7,5.2c-8.6,2.3-17.1,5-25.3,8.1c-1.4,0.5-2.8,1.1-4.2,1.6 c-1.4,0.6-3.9,0.6-5.5,5.3c3.2-1.4,6.5-2.7,9.8-4C250.5,144.8,282.8,139.3,315.5,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M408,198.1c-36-3.6-72.5-3.6-109.3-0.6c-7.8,0.7-15.6,1.7-23.3,2.8c-15.4,2.3-30.5,5.5-45.4,9.7 c-2.4,0.7-4.8,1.4-7.2,2.2c-2.6,0.9-5.1,1.8-7.7,2.8c2,1.9,4.7,2.1,7.3,1.2c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6.1-1.9 c14.9-4.2,30-7.4,45.4-9.7c7.7-1.2,15.5-2.1,23.3-2.8c36.8-3,73.3-3,109.3,0.6c7.2,0.7,14.3,1.5,21.4,2.6 c14,2.1,27.7,4.9,41.2,8.5c7.8,2.1,16,5.3,21.6,2.5c-20-6.9-41-11.8-62.4-15C422.3,199.6,415.2,198.8,408,198.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M239.7,204.7c-7.2-16.6-5.9-31.8-5-48.4c-0.4,16.7,1.8,31.5,8.8,47.1l2,4.1l-3.7,1.5L239.7,204.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M266.3,199.1c-5.8-17-6.9-32.2-4.5-49.1c-1.9,17,2.6,31.8,8.4,48c0.5,1.5,1.2,2.9,1.8,4.3l-3.8,1.3 C267.6,202.1,266.9,200.7,266.3,199.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M297.1,195.1c-4.2-17.3-5.8-32.4-5-49.6c-0.1,17.2,4.7,31.8,9,48.8l1.2,4.6l-4,0.8L297.1,195.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M330.7,192.9c-3.5-17.8-1.5-33.1,1.1-50.2c-2.1,17.2-0.6,32.4,2.9,49.5l1,4.6l-4,0.7L330.7,192.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M365.7,192.4c3-17.6,5.4-32.8,3.3-50.3c2.7,17.4,3.6,32.9,0.7,50.8l-0.8,4.8l-4-0.6L365.7,192.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M404.3,195.2c4.3-17.1,6.3-32.5,2.5-49.7c4.4,17,5.8,32.7,1.5,50.5l-1.4,4.7l-3.9-0.9L404.3,195.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M442.2,200.7c2.8-16.4,4.2-30.8,0.7-47.1c4.1,16,6.1,30.7,3.4,47.6l-0.9,4.5l-4-0.6L442.2,200.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M469.5,206c3.8-15.9,6.7-29.8,5.2-45.9c2.1,15.9,2.5,30.2-1.2,46.6l-1.1,4.3l-4-0.8L469.5,206z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M306.2,58.4c-0.4,1.6-1.4,2.8-2.4,2.7c-1-0.2-1.4-1.6-1.1-3.2s1.4-2.8,2.4-2.7S306.6,56.7,306.2,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M296.7,82.7c-0.3,1.3-1.2,2.3-2,2.2c-0.8-0.1-1.2-1.3-0.9-2.7c0.3-1.3,1.2-2.3,2-2.2 C296.6,80.2,297,81.4,296.7,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M259.8,112.2c-0.3,1.3-1.2,2.3-2,2.2c-0.8-0.1-1.2-1.3-0.9-2.7c0.3-1.3,1.2-2.3,2-2.2 C259.7,109.6,260.1,110.8,259.8,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M254.1,190.5c0,1.4-0.6,2.5-1.4,2.5c-0.8,0-1.5-1.1-1.5-2.4c0-1.4,0.6-2.5,1.4-2.5 C253.4,188,254,189.1,254.1,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M282.9,149.6c0.1,1.6-0.7,3-1.6,3c-1,0-1.8-1.3-1.8-2.9c-0.1-1.6,0.7-3,1.6-3 C282.1,146.7,282.9,148,282.9,149.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M280.3,188c0.4,1.6,0,3-1,3.2c-0.9,0.2-2-1-2.4-2.6s0-3,1-3.2C278.8,185.2,279.9,186.4,280.3,188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M311.8,169.6c0.3,1.6-0.3,3-1.2,3.1c-0.9,0.1-1.9-1.1-2.2-2.7c-0.3-1.6,0.3-3,1.2-3.1 S311.5,168,311.8,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M322.7,143.7c0,1.6-0.8,2.9-1.8,2.9s-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9S322.7,142.1,322.7,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M350.1,147.2c0,1.6-0.8,2.9-1.8,2.9s-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9S350.1,145.6,350.1,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M345.7,184.6c0,1.6-0.8,2.9-1.8,2.9s-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9S345.7,182.9,345.7,184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M386.9,158.9c0,1.6-0.8,2.9-1.8,2.9s-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9 C386.2,155.9,387,157.3,386.9,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M391.3,187.2c-0.3,1.6-1.2,2.8-2.2,2.7c-0.9-0.1-1.5-1.5-1.3-3.1c0.3-1.6,1.2-2.8,2.2-2.7 S391.6,185.6,391.3,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M431.1,181.2c-0.3,1.6-1.2,2.8-2.2,2.7c-0.9-0.1-1.5-1.5-1.3-3.1c0.3-1.6,1.2-2.8,2.2-2.7 C430.8,178.2,431.3,179.6,431.1,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M458.5,164.1c0,1.6-0.8,2.9-1.7,2.9c-1,0-1.7-1.3-1.8-2.9c0-1.6,0.8-2.9,1.7-2.9 C457.7,161.2,458.5,162.5,458.5,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M460.8,196.4c-0.1,1.6-1,2.9-2,2.8c-1-0.1-1.6-1.4-1.5-3s1-2.9,2-2.8C460.3,193.4,461,194.7,460.8,196.4z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M486.6,167.4c0,2-1,3.7-2.2,3.6c-1.2,0-2.2-1.7-2.1-3.7c0-2,1-3.7,2.2-3.6 C485.7,163.7,486.6,165.3,486.6,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M288.9,111.6c-0.2,1.4-1.1,2.5-1.9,2.4s-1.3-1.3-1.1-2.7c0.2-1.4,1.1-2.5,1.9-2.4 C288.7,109,289.1,110.2,288.9,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M269.6,74.3c-0.8,1.7-2.3,2.8-3.3,2.5s-1.2-2-0.4-3.7c0.8-1.7,2.3-2.8,3.3-2.5 C270.2,71,270.4,72.6,269.6,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M240.8,111.1c-0.5,1.8-1.8,3-2.8,2.8s-1.5-1.8-1-3.6c0.5-1.8,1.8-3,2.8-2.8 C240.8,107.8,241.3,109.4,240.8,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M233,133.9c-0.1,1.8-1,3.3-2.1,3.3s-1.9-1.5-1.8-3.3c0.1-1.8,1-3.3,2.1-3.3 C232.2,130.6,233,132.1,233,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M223.2,182.3c-0.1,1.8-1,3.3-2.1,3.3s-1.9-1.5-1.8-3.3c0.1-1.8,1-3.3,2.1-3.3 C222.4,178.9,223.2,180.4,223.2,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M247.9,165c-0.1,1.6-0.9,3-1.9,2.9s-1.7-1.4-1.7-3c0.1-1.6,0.9-3,1.9-2.9C247.2,162,248,163.3,247.9,165z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M223.8,205.8c0.3,1.4-0.1,2.7-0.9,2.8c-0.8,0.1-1.7-0.9-2-2.3c-0.3-1.4,0.1-2.7,0.9-2.8 C222.6,203.4,223.5,204.4,223.8,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M328.2,73.4c0,1.4-0.7,2.6-1.5,2.6c-0.9,0-1.6-1.1-1.6-2.6c0-1.4,0.7-2.6,1.5-2.6 C327.5,70.8,328.2,71.9,328.2,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M326.1,111.6c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.6-2.6 C325.4,109,326.1,110.2,326.1,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M361.8,71.6c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.6-2.6 C361.2,69,361.8,70.1,361.8,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M365,93.5c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.6-2.6C364.3,90.9,365,92.1,365,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M392,69.4c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.7-1-2-2.4c-0.2-1.4,0.3-2.6,1.2-2.7 C390.9,66.9,391.8,68,392,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M400.5,113.1c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.7-1-2-2.4c-0.2-1.4,0.3-2.6,1.2-2.7 C399.4,110.6,400.3,111.7,400.5,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M428.1,87.1c0.5,1.4,0.1,2.7-0.7,2.9c-0.8,0.2-1.9-0.8-2.3-2.1c-0.5-1.4-0.1-2.7,0.7-2.9 C426.6,84.8,427.7,85.8,428.1,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M444.4,120.9c0.4,1.4,0.1,2.7-0.8,2.8c-0.8,0.2-1.9-0.8-2.3-2.2c-0.4-1.4-0.1-2.7,0.8-2.8 C443,118.5,444,119.5,444.4,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M465.5,99.5c0.4,1.4,0.1,2.7-0.8,2.8c-0.8,0.2-1.9-0.8-2.3-2.2c-0.4-1.4-0.1-2.7,0.8-2.8 C464,97.1,465,98.1,465.5,99.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1WHair3);
export default __webpack_public_path__ + "static/media/m-hat1_w-hair3.a061e26064a422ef757d1451c03d77cb.svg";
export { ForwardRef as ReactComponent };